import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../../context/Translator";
import { AnchorComponent } from "../../elements";

export default function SellerProductsTableComponent({ thead, tbody, activeTab }) {
    const { t } = useContext(TranslatorContext);
    const [data, setData] = useState([]);

    useEffect(() => {
        setData(tbody || []);
    }, [tbody]);

    return (
        <div className="mc-table-responsive">
            <table className="mc-table product">
                <thead className="mc-table-head primary">
                    <tr>
                        {thead?.map((item, index) => (
                            <th key={index}>{t(item)}</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {data && data.length > 0 ? (
                        data.map((item, index) => {
                            const pImage = item?.card_img || item?.first_img
                                ? `${process.env.REACT_APP_IMG_URL}${item.card_img || item.first_img}`
                                : "";
                            const pTitle = item?.title || "N/A";
                            const pCode = item?.product_code || "N/A";
                            const pCondition = item?.product_condition || "N/A";
                            const pQty = item?.product_qty ?? 0;

                            const pCategory = typeof item?.category === "object"
                                ? item?.category?.name
                                : (item?.category || "N/A");

                            const pBrand = typeof item?.brand === "object"
                                ? item?.brand?.name
                                : (item?.brand || "N/A");

                            const pricePresent = item?.buying_price || item?.sell_price_dollar || 0;

                            return (
                                <tr key={item?.id || index}>
                                    <td><div className="mc-table-check">{pCode}</div></td>
                                    <td>
                                        <div className="mc-table-product md">
                                            {pImage && <img src={pImage} alt={pTitle} />}
                                            <div className="mc-table-group">
                                                <h6>{pTitle}</h6>
                                                <p>{pCondition}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>{pCategory}</td>
                                    <td>{pBrand}</td>
                                    <td><span className="text-capitalize">{pCondition}</span></td>
                                    <td>
                                        <div className="mc-table-price">
                                            <p>${pricePresent}</p>
                                        </div>
                                    </td>
                                    <td>{pQty}</td>
                                    <td>
                                        <div className="mc-table-action">
                                            <AnchorComponent
                                                to={`/seller-product-view/${item?.id || ''}`}
                                                state={{ item }}
                                                title="View"
                                                className="material-icons view"
                                            >
                                                visibility
                                            </AnchorComponent>

                                            {activeTab === "new" && (
                                                <AnchorComponent
                                                    to={'/seller-product-edit'}
                                                    state={{ item }}
                                                    title="Edit"
                                                    className="material-icons edit"
                                                >
                                                    edit
                                                </AnchorComponent>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan={thead?.length || 8} className="text-center py-4">
                                {t("no_products_found")}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}